var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrophone01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8327 8.33335L15.8327 10C15.8327 13.2217 13.221 15.8334 9.99935 15.8334M4.16602 8.33335V10C4.16602 13.2217 6.77769 15.8334 9.99935 15.8334M9.99935 15.8334V18.3334M6.66602 18.3334H13.3327M9.99935 12.5C8.61864 12.5 7.49935 11.3807 7.49935 10L7.49935 4.16669C7.49935 2.78597 8.61864 1.66669 9.99935 1.66669C11.3801 1.66669 12.4993 2.78598 12.4993 4.16669L12.4993 10C12.4993 11.3807 11.3801 12.5 9.99935 12.5Z",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone01);
export default __webpack_public_path__ + "static/media/microphone-01.1f619a4a95ced065350937c0c920bd4f.svg";
export { ForwardRef as ReactComponent };